import React, { useEffect, useRef, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Teaxtarea from "../../../components/elements/form/textarea";
import Button from "../../../components/elements/button";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import toast from "react-hot-toast";
import FileUpload from "../../../components/elements/form/fileUplaod";
import { useFacilityManagersSelector } from "../../../store/selectors/masterSelector";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import Signaturepad from "../../../components/signaturepad";
import Loader from "../../../components/loader";
import moment, { invalid } from "moment";
import AssetStatus from "../../Assets/_components/assetStatus";
import SelectBox from "../../../components/elements/form/selectBox";
import TaskExecutionTimeModal from "./taskExecutionTime.modal";

interface AssetsFormProps {
  _ref?: any;
  editData?: any;
  currentStatus?: any;
  onCreate?: () => void;
  onCancel?: () => void;
}

type CreateWorkOrderFormValueType = {
  workOrderID: any;
  CompletionNote: any;
  rootCause: any;
  Files: any;
  assetImage: any;
};


const CompleteIncompleteModalWorkOrder: React.FC<AssetsFormProps> = ({ _ref, editData, currentStatus, onCreate = () => { }, onCancel = () => { } }) => {
  const { control, handleSubmit, setValue, reset, formState: { errors }, watch, getValues } = useForm<CreateWorkOrderFormValueType>({
    defaultValues: {
    }
  });

  const hasEditRun = useRef(false);
  const divRef = useRef<any>(null);
  const taskExecutionTimeModalRef = useRef<HTMLDialogElement>(null);
  const pendingSubmitDataRef = useRef<any>(null);
  const [elapsedHours, setElapsedHours] = useState<number>(0);
  const [elapsedMinutes, setElapsedMinutes] = useState<number>(0);
  const [elapsedSeconds, setElapsedSeconds] = useState<number>(0);

  const { showLoader, hideLoader } = useAppLoader();
  const [showAssetLoader, setShowAssetLoader] = useState<boolean>(false);
  const [woloader, setWoloader] = useState<boolean>(false);
  const [partsAttachment, setPartsAttachment] = useState<any>(null);
  const [Files, setFiles] = React.useState<any>(null);
  const [wodetails, setWodetails] = useState<any>(null);
  const [partsItems, setPartsItems] = useState<any>([]);

  const commonApi: any = useCommonApi();
  const workOrderAPI: any = useWorkOrderApi();
  const users = useFacilityManagersSelector();

  let imgExt = ["png", "jpg", "jpeg", "webp"];

  const formReset = async () => {
    reset({});
  };

  const onOutsideClick = () => {
    handleOnClickCellEdit()
  }

  const handleOnClickCellEdit = (identifier: string = ``, e: any = null) => {
    if (identifier) {
      const cellElement = document.querySelector(`#${identifier}`) as HTMLDivElement;
      const previewElement = cellElement.querySelector(`.preview-value`) as HTMLDivElement;
      const editElement = cellElement.querySelector(`.edit-value`) as HTMLDivElement;
      if (previewElement && editElement) {
        if (cellElement.id === `${identifier}`) {
          if (!previewElement.classList.contains(`hidden`)) previewElement.classList.add(`hidden`);
          if (editElement.classList.contains(`hidden`)) editElement.classList.remove(`hidden`);
        }
      }
    }

    //resetOthersCellEditState(`part-item-name-${index}`);
    const editableList = document.querySelectorAll(`.editable`) as NodeListOf<HTMLDivElement>
    //console.log("editableList", editableList);
    for (let i = 0; i < editableList.length; i++) {
      const editableCell = editableList[i];
      const preview = editableCell.querySelector(`.preview-value`) as HTMLDivElement;
      const edit = editableCell.querySelector(`.edit-value`) as HTMLDivElement;
      if (editableCell.id !== `${identifier}`) {
        if (preview.classList.contains(`hidden`)) preview.classList.remove(`hidden`);
        if (!edit.classList.contains(`hidden`)) edit.classList.add(`hidden`);
      }
    }

  };

  const getWODetails = async (woid: any) => {
    setShowAssetLoader(true);
    const woresp: any = await new Promise((resolve, reject) => {
      workOrderAPI.GetWorkOrderByID({
        WorkOrderID: woid
      }, (resp: any) => {
        resolve(resp);
      }, (error: any) => {
        toast.error(error);
        reject(error);
      });
    }).catch((error: any) => {
      return null;
    });
    setShowAssetLoader(false);
    if (woresp && woresp.hasOwnProperty(`workOrderID`) && +woresp.workOrderID) {
      console.log("Task Details -> ", woresp);
      if (woresp.hasOwnProperty(`workOrderPartsMappingList`) && Array.isArray(woresp.workOrderPartsMappingList) && woresp.workOrderPartsMappingList.length > 0) {
        setPartsItems(woresp.workOrderPartsMappingList);
      }
      setWodetails(woresp);
    } else {
      toast.error(woresp?.message || `Failed to fetch Task details`);
    }
  };

  const executeSubmit = async (formData: any, CompletionDate: string | null) => {
    if (!Files) {
      toast.error("Please add signature in order to proceed the WO!");
      return;
    }

    if (+currentStatus === 5) {
      setWoloader(true);
      const checklistResp: any = await new Promise((resolve, reject) => {
        workOrderAPI.CheckWOTasksCompletion(
          { WorkOrderID: editData?.workOrderID },
          (resp: any) => resolve(resp),
          (error: any) => reject(error)
        );
      }).catch(() => null);
      setWoloader(false);

      if (checklistResp && checklistResp.hasIncompleteTasks) {
        toast.error(
          `Cannot complete: ${checklistResp.incompleteCount} required checklist task(s) not completed.`
        );
        return;
      }
    }

    const payloadData = new FormData();
    payloadData.append("workOrderID", editData?.workOrderID);
    payloadData.append("CompletionNote", formData?.CompletionNote);
    payloadData.append("rootCause", formData?.rootCause);
    payloadData.append("workOrderStatusID", currentStatus);
    payloadData.append('SignatureFiles', Files);
    if (CompletionDate) {
      payloadData.append("CompletionDate", CompletionDate);
    }

    const statusMapObj: any = { 5: `CloseComplete`, 6: `CloseIncomplete` };

    if (wodetails && wodetails.hasOwnProperty(`workOrderAssetMappingList`) && Array.isArray(wodetails.workOrderAssetMappingList) && wodetails.workOrderAssetMappingList.length > 0) {
      const nonoperationalassets = wodetails.workOrderAssetMappingList.filter((asset: any) => +asset.statusID !== 1);
      if (nonoperationalassets.length > 0) {
        if (window.confirm(`There are ${nonoperationalassets.length} assets which are not in operational status. Do you want to proceed?`)) {
          //Confirmed to proceed with non-operational assets
        } else {
          return;
        }
      }
    }

    if (partsItems && partsItems.length > 0) {
      const partswithemptyusedqty = partsItems.filter((part: any) => +part.usedQty < 1 && +part.assetID);
      const invalidparts = partsItems.filter((part: any) => !+part.assetID && +part.usedQty > 0);
      if (invalidparts.length > 0) {
        toast.error(`Please select asset for the parts (whose used Qty greater then zero) before proceeding!`);
        return;
      }
      if (partswithemptyusedqty.length > 0) {
        if (window.confirm(`There are ${partswithemptyusedqty.length} parts, where usage data aren't provided. Do you want to proceed?`)) {
          //Confirmed to proceed with parts having empty used quantity
        } else {
          return;
        }
      }
      const partspayload = {
        workOrderID: editData?.workOrderID,
        woSpareParts: partsItems.map((item: any) => ({
          woSparePartMappingID: item?.woSparePartMappingID || null,
          sparePartID: item.partsID,
          assetID: item.assetID,
          requiredQty: item.requiredQty,
          pickedQty: item.pickedQty,
          usedQty: item.usedQty || null,
          returnQty: item.returnQty || null,
          facilityID: wodetails.facilityID,
          subFaclityID: null,
          isPicked: true,
          isLocked: false
        }))
      };
      setWoloader(true);
      const partsstockuseresp: any = await new Promise((resolve, reject) => {
        workOrderAPI.SaveWorkOrderInventory(partspayload, (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        });
      }).catch((error: any) => {
        toast.error(error);
        return null;
      });
      setWoloader(false);
      if (partsstockuseresp && partsstockuseresp.hasOwnProperty(`code`) && +partsstockuseresp.code === 200 && partsstockuseresp.hasOwnProperty(`successful`) && partsstockuseresp.successful === true) {
        toast.success(partsstockuseresp.message || `Parts updated successfully!`);
      } else {
        toast.error(partsstockuseresp?.message || `Failed to update parts!`);
        return;
      }
    }

    setWoloader(true);
    workOrderAPI.SaveWorkOrderCompletion(payloadData, async (resp: any) => {
      if (partsAttachment) {
        const formDataAttach = new FormData();
        var i = 0;
        for (const item of partsAttachment) {
          formDataAttach.append("InputFile" + i, item);
          i++;
        }
        await new Promise((resolve, reject) => {
          formDataAttach.append("WorkOrderstatus", statusMapObj[+currentStatus]);
          formDataAttach.append("workOrderID", editData?.workOrderID);
          workOrderAPI.UploadWorkOrderCompletionAttachment(formDataAttach, (resp: any) => {
            toast.success(resp?.message);
            resolve(resp);
          }, (error: any) => {
            toast.error(error);
            reject(error);
          });
        }).catch((error: any) => { return null; });
      }
      setWoloader(false);
      toast.success(resp?.message);
      formReset();
      hasEditRun.current = false;
      onCreate();
    }, (error: any) => {
      setWoloader(false);
      toast.error(error);
    });
  };

  const onSubmit: SubmitHandler<CreateWorkOrderFormValueType> = async (data: any) => {
    if (!Files) {
      toast.error("Please add signature in order to proceed the WO!");
      return;
    }
    if (editData?.originalStartDate) {
      const totalSeconds = Math.floor(
        (moment().valueOf() - moment.utc(editData.originalStartDate).local().valueOf()) / 1000
      );
      const hrs = Math.floor(totalSeconds / 3600);
      if (hrs >= 3) {
        pendingSubmitDataRef.current = data;
        setElapsedHours(hrs);
        setElapsedMinutes(Math.floor((totalSeconds % 3600) / 60));
        setElapsedSeconds(totalSeconds % 60);
        taskExecutionTimeModalRef.current?.showModal();
        return;
      }
    }
    await executeSubmit(data, null);
  };

  const onModalResolved = async (CompletionDate: string) => {
    const formData = pendingSubmitDataRef.current;
    pendingSubmitDataRef.current = null;
    await executeSubmit(formData, CompletionDate);
  };

  const changeAttachmentHandler = (e: any) => {
    setPartsAttachment(e.target.files);
  };

  const init_page_date = async () => {
  }

  useEffect(() => {
    init_page_date();
  }, []);

  useEffect(() => {
    if (editData) {
      if (!hasEditRun.current) {
        console.log("editData", editData);
        hasEditRun.current = true;
        //Wo Details fetch
        getWODetails(editData?.workOrderID);
      }
    } else {
      formReset();
    }
  }, [editData]);

  useEffect(() => {
    if (_ref?.current) {
      _ref.current.reset = formReset;
    }
  }, [_ref]);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        onOutsideClick();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onOutsideClick]);

  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.key === 'Escape') {
        onOutsideClick();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onOutsideClick]);

  return (
    <div className={`relative`}>
      {woloader && (
        <div className={`absolute p-8`} style={{ height: "100%", width: "100%", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.5)" }}>
          <Loader />
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className={`${woloader ? `hidden` : `flex`} flex-col`}>
        <div className="flex-1 overflow-auto" style={{ minHeight: `calc(100vh - 152px)` }}>
          {/*<h4 className="font-semibold text-[0.938rem] border-gray-200 py-4 uppercase" style={{ color: "#000000", fontSize: 15 }}>General</h4>*/}

          <div className={`py-2 mb-0`}>
            <div className={`text-[0.938rem]`} style={{ color: `#000` }}>Task Number</div>
            <p className={`font-normal mt-2`} style={{ color: `#656565`, fontSize: 15 }}>{editData?.workOrderCode}</p>
          </div>

          <div className="py-2">
            <div className={`text-[0.938rem]`} style={{ color: `#000` }}>Description</div>
            <p className={`font-normal mt-2 line-clamp-2`} style={{ color: `#656565`, fontSize: 15 }} title={editData?.description}>{editData?.description}</p>
          </div>

          <Controller
            name="rootCause"
            /* rules={{ required: "Root Cause is required" }} */
            control={control}
            render={({ field: { value, onChange } }) => (
              <Teaxtarea
                label="Root Cause"
                value={value}
                onChange={onChange}
                /* required */
                placeholder="Root Cause"
                className="!my-5"
                error={errors.rootCause?.message as any}
              />
            )}
          />
          <Controller
            name="CompletionNote"
            /* rules={{ required: "Description is required" }} */
            control={control}
            render={({ field: { value, onChange } }) => (
              <Teaxtarea
                label={`Solution (${+currentStatus == 5 ? `Complete` : `In-Complete`}) Note`}
                isLabelBold={false}
                value={value}
                onChange={onChange}
                /* required */
                placeholder="Solution"
                className="!my-5"
                error={errors.CompletionNote?.message as any}
              />
            )}
          />

          {/* Impacted Assets */}
          <div>
            <h4 className="font-semibold text-[17px] pb-2">Impacted Asset</h4>
            <div className={`border border-[#043E6133] rounded-[5px] w-full overflow-x-auto mt-1  parts-table`}>
              <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>
                <div className={`w-44 min-w-44 max-w-44 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2 py-2 h-[50px] flex items-center`}>Asset ID</div>                                   {/* 144px */}
                <div className={`w-[307px] min-w-[307px] max-w-[307px] font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Asset Name</div>                  {/* 270px */}
                <div className={`w-48 min-w-48 max-w-48 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center`}>Status</div>                    {/* 112px */}
              </div>
              <div>

                {showAssetLoader && (
                  <div className={`flex items-center justify-center h-24 text-gray-500`}>
                    <Loader />
                  </div>
                )}
                {!showAssetLoader && wodetails && wodetails.hasOwnProperty(`workOrderAssetMappingList`) && wodetails.workOrderAssetMappingList?.length === 0 && (
                  <div className={`flex items-center justify-center h-24 text-gray-500`}>
                    No asset added yet.
                  </div>
                )}

                {wodetails && wodetails.hasOwnProperty(`workOrderAssetMappingList`) && wodetails.workOrderAssetMappingList?.map((asset: any, index: number) => (
                  <div className={`flex items-center flex-nowrap`} key={`part-item-${index}`}>
                    <div className={`w-44 min-w-44 max-w-44 font-normal text-[#42484B] text-[13px] px-2 min-h-12 max-h-12 flex items-center bg-[#F9F9F9] ${index < (wodetails.workOrderAssetMappingList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                      <div className={`line-clamp-1 text-ellipsis`}>{asset.assetCode}</div>
                    </div>
                    <div className={`w-[307px] min-w-[307px] max-w-[307px] font-normal text-[#42484B] text-[13px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col ${index < (wodetails.workOrderAssetMappingList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                      <div className={`preview-value line-clamp-1`} title={asset.name}>{asset.name}</div>
                    </div>
                    <div className={`w-48 min-w-48 max-w-48 font-normal text-[#42484B] text-[13px] px-2.5 min-h-12 max-h-12 flex items-center bg-[#F9F9F9] ${index < (wodetails.workOrderAssetMappingList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                      <AssetStatus
                        asset={asset}
                        onUpdate={() => {
                          getWODetails(wodetails?.workOrderID);
                        }}
                        canChange={true}
                      />
                    </div>
                  </div>
                ))}

              </div>
            </div>
          </div>

          <div className={`mt-5`}>
            <h4 className="font-semibold text-[17px] pb-2">Parts</h4>
            <div className={`border border-[#043E6133] rounded-[5px] w-full mt-1  parts-table`}>
              <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>
                <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2 py-2 h-[50px] flex items-center`}>Part Code</div>                  {/* 144px */}
                <div className={`w-[160px] min-w-[160px] max-w-[160px] font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Part Name</div> {/* 270px */}
                <div className={`w-48 min-w-48 max-w-48 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center`}>Asset</div>               {/* 112px */}
                <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Remaining Qty</div>       {/* 112px */}
                <div className={`w-24 min-w-24 max-w-24 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Qty Used</div>            {/* 112px */}
              </div>
              <div className={``} ref={divRef}>

                {showAssetLoader && (
                  <div className={`flex items-center justify-center h-24 text-gray-500`}>
                    <Loader />
                  </div>
                )}
                {!showAssetLoader && partsItems.length === 0 && (
                  <div className={`flex items-center justify-center h-24 text-gray-500`}>
                    No parts added yet.
                  </div>
                )}

                {partsItems.map((part: any, index: number) => (
                  <div className={`flex items-center flex-nowrap`} key={`part-item-${index}`}>
                    <div className={`w-28 min-w-28 max-w-28 font-normal text-[#42484B] text-[13px] px-2 min-h-12 max-h-12 flex items-center bg-[#F9F9F9] cursor-not-allowed ${index < (wodetails.workOrderPartsMappingList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                      <div className={`line-clamp-1 text-ellipsis`}>{part.partsCode}</div>
                    </div>
                    <div className={`w-[160px] min-w-[160px] max-w-[160px] font-normal text-[#42484B] text-[13px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-not-allowed ${index < (wodetails.workOrderPartsMappingList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                      <div className={`preview-value line-clamp-1`} title={part.sparePartsName}>{part.sparePartsName}</div>
                    </div>
                    <div className={`w-48 min-w-48 max-w-48 font-normal text-[#42484B] text-[13px] px-2.5 min-h-12 max-h-12 flex items-center cursor-pointer editable ${index < (wodetails.workOrderPartsMappingList.length - 1) ? `border-b border-[#043E6133]` : ``}`} id={`part-item-asset-${index}`} onClick={(e: any) => {
                      handleOnClickCellEdit(`part-item-asset-${index}`, e);
                      e.stopPropagation();
                      e.preventDefault();
                    }}>
                      <div className={`preview-value line-clamp-1`} title={part.assetName || `Click here to add data`}>{part.assetName || `--`}</div>
                      <div className={`edit-value grow hidden`}>
                        <SelectBox
                          label={``}
                          value={part.assetID ? { label: part.assetName, value: part.assetID } : null}
                          onChange={(value: any) => {
                            const updatedParts = [...partsItems];
                            updatedParts[index].assetID = value.value; // Assuming value has a value property
                            updatedParts[index].assetName = value.label; // Assuming value has a label property
                            setPartsItems(updatedParts);
                          }}
                          required
                          placeholder='Select Asset'
                          options={wodetails && wodetails.workOrderAssetMappingList?.map((asset: any) => {
                            return { label: asset.name, value: asset.assetID }
                          }) || []}
                          className={`!my-0`}
                          customStyleOption={{ control: (base: any) => ({ ...base, marginTop: `0rem`, minHeight: '32px' }) }}
                        />
                      </div>
                    </div>
                    <div className={`w-28  min-w-28 max-w-28 font-normal text-[#42484B] text-[13px] px-2.5 min-h-12 max-h-12 flex items-center bg-[#F9F9F9] cursor-not-allowed ${index < (wodetails.workOrderPartsMappingList.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                      {/* <div className={`line-clamp-1 text-ellipsis text-right grow`}>{part.pickedQty - (part.returnQty || 0)} </div> */}
                      <div className={`line-clamp-1 text-ellipsis text-right grow`}>{part.remainingQty ?? 0}</div>
                    </div>
                    <div className={`w-24 min-w-24 max-w-24 font-normal text-[#42484B] text-[13px] px-2.5 min-h-12 max-h-12 flex items-center cursor-pointer editable ${index < (wodetails.workOrderPartsMappingList.length - 1) ? `border-b border-[#043E6133]` : ``}`} id={`part-item-used-qty-${index}`} onClick={(e: any) => {
                      handleOnClickCellEdit(`part-item-used-qty-${index}`, e);
                      e.stopPropagation();
                      e.preventDefault();
                    }}>
                      <div className={`preview-value grow text-right`} title={part.usedQty || `Click here to add data`}>{part.usedQty || 0}</div>
                      <div className={`edit-value hidden`}>
                        <input
                          type="tel"
                          className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right`}
                          value={part.usedQty || 0}
                          onChange={(e) => {
                            const newQty = +e.target.value;
                            var usedQty = isNaN(newQty) ? 0 : newQty;
                            if (usedQty > (part.remainingQty ?? 0)) {
                              usedQty = part.remainingQty ?? 0;
                            }
                            const updatedParts = [...partsItems];
                            updatedParts[index].usedQty = isNaN(newQty) ? 0 : usedQty;
                            setPartsItems(updatedParts);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}

              </div>
            </div>
          </div>





          <Controller
            name="assetImage"
            control={control}
            render={({ field: { value, onChange } }) => (
              <FileUpload
                label="File name"
                value={value}
                isMulti={true}
                accept=".jpg, .jpeg, .png"
                isFigmaType={true}
                retainFiles={true}
                allowedExt={imgExt}
                onChange={(e: any, files: any) => {
                  changeAttachmentHandler(e);
                  onChange(e.target.files[0]);
                }}
                placeholder="Choose Processing Facility"
              />
            )}
          />

          <Controller
            name="Files"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Signaturepad
                className={`!my-5`}
                onComplete={(data, file) => {
                  console.log("Signature completed", data);
                  console.log("Signature File -> ", file);
                  setFiles(file);
                }}
              />
            )}
          />

        </div>

        <div className="flex justify-end gap-2 flex-shrink-0 pt-5 pb-1 border-t" style={{ borderTopColor: `#50575B`, backgroundColor: `#fff`, position: `sticky`, bottom: 0 }}>
          <Button type="submit" working={woloader} customstyle={{ background: `#2D6A32`, width: 120, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }}>Save</Button>
          <Button type="button" theme="secondary" disabled={woloader} onClick={() => {
            formReset();
            onCancel();
          }} customstyle={{ width: 110, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }}>
            Cancel
          </Button>
        </div>
      </form>

      <TaskExecutionTimeModal
        _ref={taskExecutionTimeModalRef}
        originalStartDate={editData?.originalStartDate || ''}
        initialHours={elapsedHours}
        initialMinutes={elapsedMinutes}
        initialSeconds={elapsedSeconds}
        onResolved={onModalResolved}
      />
    </div>
  );
};

export default CompleteIncompleteModalWorkOrder;
